import { Component } from '@angular/core';
import {Router} from "@angular/router";
import {AuthService, MessageService, RegistrationService} from "@services";
import Swal from "sweetalert2";
import {MsalService} from "@azure/msal-angular";

@Component({
  selector: 'app-politica-datos-personales',
  templateUrl: './politica-datos-personales.component.html',
  styleUrls: ['./politica-datos-personales.component.scss']
})
export class PoliticaDatosPersonalesComponent  {

  constructor(private router: Router,
              private registrationService: RegistrationService,
              private authService: AuthService,
              private popupAlert: MessageService,
              private msalAuthService: MsalService) { }



  confirmar(): void {
    const userActual = this.authService.getLoggedUser();
    const oidToken = userActual.oid;
    const nombre = userActual.given_name;
    const apellido = userActual.family_name;

    let data = {
      "fecha": new Date(Date.now()),
      "id_usuario": oidToken,
      "nombre": nombre,
      "apellido": apellido
    }
    // tslint:disable-next-line: no-unused-variable
    this.registrationService.addPoliticaSeguridad(data).subscribe(resp => {// NOSONAR

      let data = {
        "idUser": oidToken,
        "idRole": "58EDA51F-7E19-47C4-947F-F359BD1FC732"
      }
      // tslint:disable-next-line: no-unused-variable
      this.registrationService.addUserRol(data).subscribe(resp => {
        Swal.fire({
          icon: 'success',
          title: 'Registro existoso',
          confirmButtonColor: '#0000FF',
          allowEscapeKey: false,
          allowOutsideClick: false,
          confirmButtonText: 'OK',
          text: 'Será redigirido a la página principal y deberá iniciar sesión nuevamente para acceder a los servicios.',
        }).then((result) => {
          this.msalAuthService.logoutPopup({
            mainWindowRedirectUri: "/"
          }).subscribe(resp => {
            this.popupAlert.infoAlert("¡Sesión cerrada exitosamente!", 4000);
            localStorage.clear();
            this.authService.setCurrentUser(null);
          });
        });
      }, error => {
        this.popupAlert.errorAlert(
          'Ocurrió un error al registrarse',
          4000);
        console.log("No se pudo guardar el rol", error);
      })

    }, error => {
      this.popupAlert.errorAlert(
        'Ocurrió un error al guardar la política de datos personales.',
        4000);
      console.log("No se pudo guardar la politica de datos", error);
    })
  }

  noAceptar(): void {
    this.router.navigateByUrl('/').then(resp => location.reload());
  }

}
